






















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Bandeau extends Vue {
  @Prop({ default: {} }) readonly Config: any;
}
